export default __webpack_public_path__ + "static/media/add-light.b4c25ee7.svg";